import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useTheme } from '../../hooks/useTheme';
import ColourLibraryContent from '../../components/shared/ColourLibraryContent';

interface ColorLibraryScreenProps {
  onTabPress?: (tab: string) => void;
}

/**
 * In-app Colour Library tab — same content as the public Colour Library,
 * rendered inside the app layout with sidebar (private toolkit approach).
 */
const ColorLibraryScreen: React.FC<ColorLibraryScreenProps> = ({
  onTabPress: _onTabPress,
}) => {
  const { colors } = useTheme();

  return (
    <View style={[styles.container, { backgroundColor: colors.background }]}>
      <ColourLibraryContent aboveBottomTabBar />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default ColorLibraryScreen;
